import { useEffect, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../Authentification/Auth';
import { IdBCContext } from '../IdBCContext';
import API_BASE_URL from './config';

const AppelAPIDomicile = ({
  domicileData, setLancer, Lancer, save,
  setApiResponse, setAppelDomicile, 
  filledData, usedUrl, lancerSave, setLancerSave,
  setError // optionnel pour afficher dans le parent
}) => {
  const { token, isTokenExpired } = useAuth();
  const { idBC } = useContext(IdBCContext);

  useEffect(() => {
    isTokenExpired();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (token && Lancer) {
      fetchData();
    }
  }, [token, Lancer]);

  useEffect(() => {
    if (token && lancerSave) {
      fetchDataToSave(filledData, usedUrl);
    }
  }, [token, lancerSave]);

  const fetchDataToSave = async (filledData, usedUrl) => {
    filledData.save = true;
    const options = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };

    try {
      await axios.post(usedUrl, filledData, options);
    } catch (error) {
      console.error("Erreur lors de l'envoi SAVE :", error);
      if (setError) setError("Erreur lors de la sauvegarde.");
    } finally {
      setLancerSave(false);
    }
  };

  const fetchData = async () => {
    const apiUrl = `${API_BASE_URL}/aps_PDomicile_Global`;
    const data = {
      IdBC: idBC,
      TypeDeLogement: domicileData.TypeDeLogement,
      NbPersonnes: domicileData.NbPersonnes,
      Surface: domicileData.Surface,
      ConsommationConnue: domicileData.ConsommationConnue,
      Etiquette: domicileData.Etiquette,
      DateConstruction: domicileData.DateConstruction,
      Renovation: domicileData.Renovation,
      Pays: domicileData.Pays,
      ElectriciqueEuro: domicileData.ElectriciqueEuro,
      ElectriciqueUnit: domicileData.ElectriciqueUnit,
      ChauffageUrbainEuro: domicileData.ChauffageUrbainEuro,
      ChauffageUrbainUnit: domicileData.ChauffageUrbainUnit,
      GplEuro: domicileData.GplEuro,
      GplUnit: domicileData.GplUnit,
      GazEuro: domicileData.GazEuro,
      GazUnit: domicileData.GazUnit,
      ChauffageBois: domicileData.ChauffageBois,
      BoisEuro: domicileData.BoisEuro,
      BoisUnit: domicileData.BoisUnit,
      FioulEuro: domicileData.FioulEuro,
      FioulUnit: domicileData.FioulUnit,
      PanneauSol: domicileData.PanneauSol,
      PanneauPhoto: domicileData.PanneauPhoto,
      Eolienne: domicileData.Eolienne,
      ChauffageElectrique: domicileData.ChauffageElectrique,
      ChauffageFioulCollectif: domicileData.ChauffageFioulCollectif,
      ChauffageFioulIndividuel: domicileData.ChauffageFioulIndividuel,
      ChauffageGazCollectif: domicileData.ChauffageGazCollectif,
      ChauffageGazIndividuel: domicileData.ChauffageGazIndividuel,
      ChauffageGPL: domicileData.ChauffageGPL,
      ChauffageReseau: domicileData.ChauffageReseau,
      save: save
    };

    
    const options = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };

    try {
      const result = await axios.post(apiUrl, data, options);
      setAppelDomicile(0, data, apiUrl);
      setApiResponse(result.data);
    } catch (error) {
      console.error("Erreur lors de l'envoi DOMICILE :", error);
      if (setError) setError("Erreur lors du calcul du domicile.");
    } finally {
      setLancer(false);
    }
  };

  return null;
};

export default AppelAPIDomicile;